import Api from '../Api';

import { url } from './config';
import { CreditCompany } from './types';

const api = new Api<CreditCompany>(url);

export default api;
